import { DEV_SUMMARY_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { StringValue } from '../../../value/types.tsx';
import type { TransformedDevSummary } from '../types.tsx';
import messages from './messages.tsx';

const getDevSummaryValue: StringValue<TransformedDevSummary> = (field, formatMessage) => {
	if (formatMessage && field) {
		if (field.isMerged) {
			return formatMessage(messages.merged);
		}
		if (field.isUnderReview) {
			return formatMessage(messages.underReview);
		}
		if (field.commitCount) {
			return formatMessage(messages.commit, {
				count: field.commitCount,
			});
		}
	}
	return '';
};

export const devSummaryStringValueHandler = {
	[DEV_SUMMARY_CF_TYPE]: getDevSummaryValue,
};
